
/* injects from baggage-loader */

'use strict';

import ProjectInvestmentWizardStep1Controller from './projectinvestmentwizard.step1.controller';
import ProjectInvestmentWizardStep1Template from './projectinvestmentwizard.step1.html';

export default class ProjectInvestmentWizardStep1Component {
		constructor() {
				this.templateUrl = ProjectInvestmentWizardStep1Template;
				this.controller = ProjectInvestmentWizardStep1Controller;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				// this.bindings = { };
		}
}



// WEBPACK FOOTER //
// ./src/app/pages/projectInvestmentWizard/step1/projectinvestmentwizard.step1.component.js